import { useEffect, useState } from 'react';
import { dashboardService } from '../../queries/dashboard';
import { getCurrentWeekNumber } from '../../utils/week';
import useUserMemory from '../use-user-memory';

const useWeekChart = () => {
  const { memoryUserUuid } = useUserMemory();

  const [week, setWeek] = useState<number>(getCurrentWeekNumber);
  const [data, setData] = useState<Record<string, number>>({});

  useEffect(() => {
    if (!memoryUserUuid) return;

    const fetchData = async () => {
      const response = await dashboardService.getWeekChart(
        memoryUserUuid,
        week
      );
      setData(response);
    };
    fetchData();
  }, [week, memoryUserUuid]);

  return { week, setWeek, data };
};

export default useWeekChart;
